const readImage = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onerror = (error) => {
            reject(error);
        };

        reader.onload = (event) => {
            resolve(event.target.result);
        };

        reader.readAsDataURL(file);
    });
};

const validateImage = async (file, opts) => {
    return new Promise(async (resolve, reject) => {
        let url = await readImage(file);
        if (!url) return reject(new Error('No URL'));
        let img = new window.Image();

        img.onerror = () => {
            let error = new Error('Image load error');
            error.code = 'load_error';
            reject(error);
        };

        img.onload = () => {
            var height = img.height;
            var width = img.width;
            let aspect = height / width;
            let error = new Error();

            if (opts.width && width < opts.width) {
                error.message = `Image must be at least ${opts.width} pixels wide.`;
                error.code = 'invalid_width';
                reject(error);
                return;
            }

            if (opts.height && height < opts.height) {
                error.message = `Image must be at least ${opts.width} pixels tall.`;
                error.code = 'invalid_height';
                reject(error);
                return;
            }

            if (opts.aspect && aspect !== opts.aspect) {
                error.message = `Image must be square`;
                error.code = 'invalid_aspect';
                reject(error);
                return;
            }

            resolve(url);
        };
        img.src = url;
    });
};

export default validateImage;
